<template>
  <div class="code-paster">
    <div class="container-holder">
      <div class="editor">
        <textarea v-model="code" :placeholder="t('code_editor-placeholder')"></textarea>
      </div>
      <div class="preview" v-html="code"></div>
    </div>
    <div class="toolbar">
      <button class="btn cancel-btn" @click="cancel">{{ t('code_editor-cancel') }}</button>
      <button class="btn btn-success save-btn" @click="saveCode">{{ t('code_editor-save') }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "codeEditor",
  props: {
    html: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      code: this.html,
    };
  },
  methods: {
    t(term, replaces) {
      return this.$root.t(term, replaces);
    },
    saveCode() {
      this.$emit("saveEmail", this.code);
    },
    cancel() {
      this.$emit("cancelEmail");
    },
  },
};
</script>

<style scoped lang="scss">
.code-paster {
  position: fixed;
  z-index: 99;
  width: 100%;
  height: 100%;
  background: #fff;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
}

.container-holder {
  flex: 1;
  display: flex;
  width: 100%;
  height: 100%;
}

.editor,
.preview {
  flex: 1;
  padding: 15px;
  border: 1px solid #ccc;
  overflow: auto;
  height: calc(100vh - 60px);
}

.editor {
  background: #f7f7f7;
}

textarea {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  resize: none;
  font-family: monospace;
  font-size: 14px;
  padding: 10px;
  background: #fafafa;
}

.preview {
  background: #fff;
}

.toolbar {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  border-top: 1px solid #ccc;
  background: #f8f8f8;
  position: fixed;
  height: 60px;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 999;
}

.btn {
  padding: 8px 15px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  margin-left: 10px;
}

.cancel-btn {
  background: #ccc;
}
</style>
